import { Route } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { RoleGuard } from '../guards/role.guard';

export const managersRoutes: Route[] = [
  {
    path: 'managers-accounts/supervisors-accounts',
    loadComponent: () =>
      import(
        '../../features/managers/pages/supervisors-list/supervisors-list'
      ).then((mod) => mod.SupervisorsList),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'managers-accounts/dispatchers-accounts',
    loadComponent: () =>
      import(
        '../../features/managers/pages/dispatchers-list/dispatchers-list'
      ).then((mod) => mod.DispatchersList),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'managers/manager-details/:id',
    loadComponent: () =>
      import(
        '../../features/managers/pages/manager-details/manager-details'
      ).then((mod) => mod.ManagerDetails),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
];
